import { jsx } from '@emotion/react/jsx-runtime';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createComponentWithRef, useSlot, useAdaptiveHeightContext } from '@nettbureau/core';
import { useCss } from '@nettbureau/styling';
import { useIconSize } from './use-icon-size.js';

/**
 * Icons are used to represent a concept or action in a compact form.
 */ const Icon = createComponentWithRef((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('Icon', props, ref);
    const { className, color = 'inherit', colorTone = 'medium', css, icon, inline = false, size, ...svgProps } = mergedProps;
    const adaptiveHeight = useAdaptiveHeightContext();
    const iconSize = useIconSize(size);
    const iconCss = useCss(({ theme, mixins })=>[
            {
                display: inline ? 'inline-flex' : 'flex'
            },
            mixins.size({
                height: iconSize,
                width: iconSize
            }),
            mixins.typography({
                color,
                colorTone
            }),
            adaptiveHeight && mixins.spacing({
                margin: {
                    y: `calc((${theme.heights[adaptiveHeight]}px - ${iconSize}) / 2)`
                }
            }),
            css
        ]);
    return /*#__PURE__*/ jsx(FontAwesomeIcon, {
        "data-icon": true,
        ...svgProps,
        ref: mergedRef,
        className: className,
        css: iconCss,
        icon: icon
    });
});

export { Icon };
//# sourceMappingURL=icon.js.map
